import { render, staticRenderFns } from "./TranslationsEditor.vue?vue&type=template&id=7df2c51b&"
import script from "./TranslationsEditor.vue?vue&type=script&lang=js&"
export * from "./TranslationsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports